import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ym from 'react-yandex-metrika';

import { getCurrentYearCourseId } from 'common.components/course/selectors';
import { actions as lessonActions } from 'common.components/lesson';
import * as lessonViewActions from 'common.components/lesson-view.store/actions';

export type MetrikaParams = Record<string, string | number | null> | undefined;

const usePrepLessonClick = (commonMetrikaParams: MetrikaParams = {}) => {
    const dispatch = useDispatch();
    const { clearEditor } = lessonActions;
    const { toggleModal, loadLessonViewData } = lessonViewActions;
    const courseId = useSelector(getCurrentYearCourseId);

    const handlePrepLessonClick = useCallback(
        (lessonId: number, lessonMetrikaParams: MetrikaParams) => {
            ym('reachGoal', 'teacher_vitrina_click_prepared_lesson', {
                ...commonMetrikaParams,
                ...lessonMetrikaParams,
                lesson_id: lessonId,
            });

            dispatch(clearEditor());
            dispatch(
                loadLessonViewData({
                    lessonId,
                    courseId,
                })
            );
            dispatch(toggleModal(true));
        },
        [courseId, clearEditor, commonMetrikaParams, dispatch, loadLessonViewData, toggleModal]
    );

    return { handlePrepLessonClick };
};

export default usePrepLessonClick;
